/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from './API';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMinimumAppVersion = /* GraphQL */ `query GetMinimumAppVersion {
  getMinimumAppVersion {
    build
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMinimumAppVersionQueryVariables,
  APITypes.GetMinimumAppVersionQuery
>;
export const listContacts =
  /* GraphQL */ `query ListContacts($StartPos: Int, $Search: String, $Type: String) {
  listContacts(StartPos: $StartPos, Search: $Search, Type: $Type) {
    items {
      AccountID
      ContactID
      ContactNumber
      FirstName
      LastName
      AccountName
      PortalAccountName
      AccountType
      PrimaryEmail
      PersonalMobile
      TelHome
      DataQualityIssue
      ContactStatus
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListContactsQueryVariables,
    APITypes.ListContactsQuery
  >;
export const listAdviserContacts = /* GraphQL */ `query ListAdviserContacts(
  $StartPos: Int
  $Search: String
  $professionalContactID: String
  $Type: String
) {
  listAdviserContacts(
    StartPos: $StartPos
    Search: $Search
    professionalContactID: $professionalContactID
    Type: $Type
  ) {
    items {
      AccountID
      ContactID
      ContactNumber
      FirstName
      LastName
      AccountName
      PortalAccountName
      AccountType
      PrimaryEmail
      PersonalMobile
      TelHome
      DataQualityIssue
      ContactStatus
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdviserContactsQueryVariables,
  APITypes.ListAdviserContactsQuery
>;
export const listAdvisersForAdminList =
  /* GraphQL */ `query ListAdvisersForAdminList($StartPos: Int, $Search: String) {
  listAdvisersForAdminList(StartPos: $StartPos, Search: $Search) {
    items {
      ProfessionalContactID
      ProfessionalFirmID
      FirstName
      LastName
      FirmName
      PrimaryEmail
      Type
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListAdvisersForAdminListQueryVariables,
    APITypes.ListAdvisersForAdminListQuery
  >;
export const getMaintenanceModeForContact =
  /* GraphQL */ `query GetMaintenanceModeForContact($ContactID: String) {
  getMaintenanceModeForContact(ContactID: $ContactID) {
    Mode
    Message
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetMaintenanceModeForContactQueryVariables,
    APITypes.GetMaintenanceModeForContactQuery
  >;
export const getDashboard =
  /* GraphQL */ `query GetDashboard($ContactID: String) {
  getDashboard(ContactID: $ContactID) {
    account {
      AccountID
      AccountName
      AccountNumber
      AccountStatus
      AccountType
      Adviser
      ClientType
      ModifiedOn
      IntroducerFirm
      ProfessionalContact
      Owner
      PropositionType
      StaffReferrer
      Status
      Paraplanner
      AddressLine1
      AddressLine2
      City
      PostCode
      County
      Country
      ServiceManager
      PortalAccountName
      AccountCurrency
      DataQualityIssue
      FPStatus
      __typename
    }
    planOwners {
      AccountID
      PlanOwnerID
      Label
      IsAboveTheLine
      Plans {
        PlanID
        AccountID
        PortalOwnerID
        AccountName
        ParentAccountID
        ModifiedOn
        CurrentStatus
        CustodianProvider
        EffectiveDate
        ModelPortfolio
        ParentPlanID
        PlanType
        PlanNumber
        Product
        ProductBasis
        ProposalRef
        Provider
        ServicingRights
        ValuationDate
        InvestmentProposition
        RealisedGainLossHomeCcy
        UnrealisedGainLossAcctCcy
        RiskMandate
        ModelPortfolioSegmentation
        ModelPortfolioRiskLevel
        MabelModelPortfolio
        WrapperAccountType
        OnOffPlatform
        OwnershipCategory
        GroupSegment
        ProductCategory
        Owner1
        Owner2
        PortalOwnershipName
        PlanCcy
        PlanValue
        RolledUpPlanValue
        AccountCcy
        PlanValueInAcctCcy
        ModelPortfolioName
        ModelPortfolioRiskMandate
        ModelPortfolioMgmtBasis
        Bank
        BankAccountName
        BankSortCode
        BankAccountNumber
        HoldsInHouseFunds
        IsDisplayWrapper
        ExtraPlanDescriptor
        IBAN
        ParentProvider
        ParentProduct
        NominatedAccountPlanID
        NominatedAccountPlanNumber
        NominatedAccountPlanSortCode
        NominatedAccountProduct
        NominatedAccountProductProvider
        NominatedAccountValidatedAccount
        NominatedAccountWithdrawals
        NominatedAccountCreatedOn
        UncrystallisedPlanValue
        CrystallisedPlanValue
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDashboardQueryVariables,
    APITypes.GetDashboardQuery
  >;
export const getContactStatus =
  /* GraphQL */ `query GetContactStatus($ContactID: String) {
  getContactStatus(ContactID: $ContactID)
}
` as GeneratedQuery<
    APITypes.GetContactStatusQueryVariables,
    APITypes.GetContactStatusQuery
  >;
export const getSaltusOwners =
  /* GraphQL */ `query GetSaltusOwners($ContactID: String) {
  getSaltusOwners(ContactID: $ContactID) {
    items {
      BusinessUnitMainPhone
      BusinessUnitBusinessType
      BusinessUnitEmail
      Position
      SiteName
      SiteEmail
      SitePhone
      PropositionStyle
      PropositionType
      SaltusType
      FirstName
      LastName
      WorkPhone
      MobilePhone
      PrimaryEmail
      SecondaryEmail
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSaltusOwnersQueryVariables,
    APITypes.GetSaltusOwnersQuery
  >;
export const getContact = /* GraphQL */ `query GetContact($ContactID: String) {
  getContact(ContactID: $ContactID) {
    AccountID
    ContactID
    ContactNumber
    FirstName
    LastName
    AccountName
    PortalAccountName
    AccountType
    PrimaryEmail
    PersonalMobile
    TelHome
    DataQualityIssue
    ContactStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContactQueryVariables,
  APITypes.GetContactQuery
>;
export const getContactsForAccount =
  /* GraphQL */ `query GetContactsForAccount($ContactID: String) {
  getContactsForAccount(ContactID: $ContactID) {
    items {
      AccountID
      ContactID
      ContactNumber
      FirstName
      LastName
      AccountName
      PortalAccountName
      AccountType
      PrimaryEmail
      PersonalMobile
      TelHome
      DataQualityIssue
      ContactStatus
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetContactsForAccountQueryVariables,
    APITypes.GetContactsForAccountQuery
  >;
export const getProfessionalContact =
  /* GraphQL */ `query GetProfessionalContact($ProfessionalContactID: String) {
  getProfessionalContact(ProfessionalContactID: $ProfessionalContactID) {
    ProfessionalFirmID
    ProfessionalContactID
    FirstName
    LastName
    JobTitle
    PrimaryEmail
    Mobile
    Telephone
    Position
    ContactType
    Type
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetProfessionalContactQueryVariables,
    APITypes.GetProfessionalContactQuery
  >;
export const getPlanISASub =
  /* GraphQL */ `query GetPlanISASub($ContactID: String, $PlanID: String!) {
  getPlanISASub(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    ISASub {
      ContactID
      SubscriptionStatus
      CFY
      CFYSettings
      CFYAllowanceInHomeCcy
      CFYAmountSubscribedInHomeCcy
      CFYAllowanceRemainingInHomeCcy
      PFY
      PFYSettings
      PFYAllowanceInHomeCcy
      PFYAmountSubscribedInHomeCcy
      PFYAllowanceRemainingInHomeCcy
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanISASubQueryVariables,
    APITypes.GetPlanISASubQuery
  >;
export const getPlanAssetAllocation =
  /* GraphQL */ `query GetPlanAssetAllocation($ContactID: String, $PlanID: String!) {
  getPlanAssetAllocation(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    ByAssetClass {
      Label
      Percentage
      __typename
    }
    ByRegion {
      Label
      Percentage
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanAssetAllocationQueryVariables,
    APITypes.GetPlanAssetAllocationQuery
  >;
export const getDashboardAssetAllocation =
  /* GraphQL */ `query GetDashboardAssetAllocation($ContactID: String) {
  getDashboardAssetAllocation(ContactID: $ContactID) {
    ByAssetClass {
      Label
      Percentage
      __typename
    }
    ByRegion {
      Label
      Percentage
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDashboardAssetAllocationQueryVariables,
    APITypes.GetDashboardAssetAllocationQuery
  >;
export const getPlanHoldings =
  /* GraphQL */ `query GetPlanHoldings($ContactID: String, $PlanID: String!) {
  getPlanHoldings(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    Holdings {
      HoldingID
      HoldingCurrency
      ValueInHoldingCurrency
      HoldingPercentOfPlan
      Holding
      HoldingShortName
      HoldingType
      OnOffPlatform
      DirectIndirect
      AssetClass
      AssetClassGroup
      ValueInAccountCurrency
      AccountCurrency
      NetYield
      ValuationDate
      HoldingUnits
      HoldingPrice
      BookcostInAccountCurrency
      SecurityID
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanHoldingsQueryVariables,
    APITypes.GetPlanHoldingsQuery
  >;
export const getPlanContributionsAndWithdrawals =
  /* GraphQL */ `query GetPlanContributionsAndWithdrawals($ContactID: String, $PlanID: String!) {
  getPlanContributionsAndWithdrawals(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    ContributionsAndWithdrawals {
      ContWithID
      TransType
      TransCurrentStatus
      Reason
      Amount
      Frequency
      AnnualisedAmount
      EffectiveDate
      EndDate
      LastDate
      NextDate
      Currency
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanContributionsAndWithdrawalsQueryVariables,
    APITypes.GetPlanContributionsAndWithdrawalsQuery
  >;
export const getPlanTransactions =
  /* GraphQL */ `query GetPlanTransactions($ContactID: String, $PlanID: String!) {
  getPlanTransactions(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    Transactions {
      TransactionID
      TransactionCategory
      TransactionDate
      ModifiedOn
      TransactionType
      TransactionAmount
      TransactionUnits
      TransactionPrice
      FlowType
      ActualAmount
      Month
      Year
      Description
      FPStatus
      BookcostInAccountCurrency
      ProfitAndLossInAccountCurrency
      CategoryLookupCode
      TypeCategoryLookupCode
      PlanCcy
      AmountInTransCcy
      TransCcy
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanTransactionsQueryVariables,
    APITypes.GetPlanTransactionsQuery
  >;
export const getPlanPerformanceYTD =
  /* GraphQL */ `query GetPlanPerformanceYTD($ContactID: String, $PlanID: String!) {
  getPlanPerformanceYTD(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    Performance {
      ProfitLoss {
        Amount
        Percentage
        PositiveCashFlow
        NegativeCashFlow
        NetCashFlow
        Start
        End
        __typename
      }
      Selected
      Period
      Sample
      Label
      Enabled
      Data {
        PeriodEndDate
        Performance
        IndexedPerformance
        PercentPerformance
        PercentReturn
        PreviousIndexedPeformance
        PreviousIndexedPeformanceIndex
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanPerformanceYTDQueryVariables,
    APITypes.GetPlanPerformanceYTDQuery
  >;
export const getAccountPerformanceYTD =
  /* GraphQL */ `query GetAccountPerformanceYTD($ContactID: String) {
  getAccountPerformanceYTD(ContactID: $ContactID) {
    items {
      ProfitLoss {
        Amount
        Percentage
        PositiveCashFlow
        NegativeCashFlow
        NetCashFlow
        Start
        End
        __typename
      }
      Selected
      Period
      Sample
      Label
      Enabled
      Data {
        PeriodEndDate
        Performance
        IndexedPerformance
        PercentPerformance
        PercentReturn
        PreviousIndexedPeformance
        PreviousIndexedPeformanceIndex
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAccountPerformanceYTDQueryVariables,
    APITypes.GetAccountPerformanceYTDQuery
  >;
export const getPlanValueOverTime =
  /* GraphQL */ `query GetPlanValueOverTime($ContactID: String, $PlanID: String!) {
  getPlanValueOverTime(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    Error
    ValueOverTime {
      PeriodEndDate
      Frequency
      ValueEnd
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPlanValueOverTimeQueryVariables,
    APITypes.GetPlanValueOverTimeQuery
  >;
export const getAccountValueOverTime =
  /* GraphQL */ `query GetAccountValueOverTime($ContactID: String) {
  getAccountValueOverTime(ContactID: $ContactID) {
    items {
      PeriodEndDate
      Frequency
      ValueEnd
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAccountValueOverTimeQueryVariables,
    APITypes.GetAccountValueOverTimeQuery
  >;
export const getNotificationsForContact =
  /* GraphQL */ `query GetNotificationsForContact($ContactID: String) {
  getNotificationsForContact(ContactID: $ContactID) {
    items {
      id
      ContactID
      Message
      LinkUrl
      LinkText
      LinkRedirectCommand
      LinkActionApprovalDocID
      IsRead
      IsClicked
      ShowToast
      SendEmail
      EmailSubject
      EmailMessage
      disabled
      expireAt
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetNotificationsForContactQueryVariables,
    APITypes.GetNotificationsForContactQuery
  >;
export const getSignatureForContact =
  /* GraphQL */ `query GetSignatureForContact($ContactID: String, $ResourceId: String) {
  getSignatureForContact(ContactID: $ContactID, ResourceId: $ResourceId) {
    id
    AccountID
    ContactID
    FirstName
    LastName
    Signature
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSignatureForContactQueryVariables,
    APITypes.GetSignatureForContactQuery
  >;
export const getRedirectCommandsForContact =
  /* GraphQL */ `query GetRedirectCommandsForContact($ContactID: String) {
  getRedirectCommandsForContact(ContactID: $ContactID) {
    items {
      id
      ContactID
      Command
      reminderCount
      redirectStatus
      createdAt
      updatedAt
      completedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRedirectCommandsForContactQueryVariables,
    APITypes.GetRedirectCommandsForContactQuery
  >;
export const getRedirectActionForContact =
  /* GraphQL */ `query GetRedirectActionForContact($ContactID: String, $Command: String!) {
  getRedirectActionForContact(ContactID: $ContactID, Command: $Command) {
    Command
    DisplayName
    RedirectUrl
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRedirectActionForContactQueryVariables,
    APITypes.GetRedirectActionForContactQuery
  >;
export const assertRedirectActionForContact =
  /* GraphQL */ `query AssertRedirectActionForContact($ContactID: String, $Command: String!) {
  assertRedirectActionForContact(ContactID: $ContactID, Command: $Command) {
    id
    ContactID
    Command
    reminderCount
    redirectStatus
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AssertRedirectActionForContactQueryVariables,
    APITypes.AssertRedirectActionForContactQuery
  >;
export const listPortalImportZips = /* GraphQL */ `query ListPortalImportZips {
  listPortalImportZips {
    items {
      PortalImportStamp
      CSVCount
      ImportStatus
      Database
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPortalImportZipsQueryVariables,
  APITypes.ListPortalImportZipsQuery
>;
export const getDevicesByUserID =
  /* GraphQL */ `query GetDevicesByUserID($UserID: String) {
  getDevicesByUserID(UserID: $UserID) {
    items {
      id
      DeviceID
      UserID
      ContactID
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDevicesByUserIDQueryVariables,
    APITypes.GetDevicesByUserIDQuery
  >;
export const getTeamMemberInfo =
  /* GraphQL */ `query GetTeamMemberInfo($SaltusContact: String) {
  getTeamMemberInfo(SaltusContact: $SaltusContact) {
    Link
    Title
    Image
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTeamMemberInfoQueryVariables,
    APITypes.GetTeamMemberInfoQuery
  >;
export const getPasswordPolicy = /* GraphQL */ `query GetPasswordPolicy {
  getPasswordPolicy {
    MinimumLength
    RequireUppercase
    RequireLowercase
    RequireNumbers
    RequireSymbols
    TemporaryPasswordValidityDays
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPasswordPolicyQueryVariables,
  APITypes.GetPasswordPolicyQuery
>;
export const getClientUsers = /* GraphQL */ `query GetClientUsers {
  getClientUsers {
    items {
      Username
      UserCreateDate
      UserLastModifiedDate
      Email
      ContactID
      Status
      Role
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientUsersQueryVariables,
  APITypes.GetClientUsersQuery
>;
export const getClientUsersByEmail =
  /* GraphQL */ `query GetClientUsersByEmail($Email: String) {
  getClientUsersByEmail(Email: $Email) {
    items {
      Username
      UserCreateDate
      UserLastModifiedDate
      Email
      ContactID
      Status
      Role
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetClientUsersByEmailQueryVariables,
    APITypes.GetClientUsersByEmailQuery
  >;
export const getAdviserUsers = /* GraphQL */ `query GetAdviserUsers {
  getAdviserUsers {
    items {
      Username
      UserCreateDate
      UserLastModifiedDate
      Email
      ProfessionalContactID
      ProfContactID
      EmployeeID
      Status
      Role
      Type
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdviserUsersQueryVariables,
  APITypes.GetAdviserUsersQuery
>;
export const getAdviserUsersByEmail =
  /* GraphQL */ `query GetAdviserUsersByEmail($Email: String) {
  getAdviserUsersByEmail(Email: $Email) {
    items {
      Username
      UserCreateDate
      UserLastModifiedDate
      Email
      ProfessionalContactID
      ProfContactID
      EmployeeID
      Status
      Role
      Type
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAdviserUsersByEmailQueryVariables,
    APITypes.GetAdviserUsersByEmailQuery
  >;
export const getAdminUsers = /* GraphQL */ `query GetAdminUsers {
  getAdminUsers {
    items {
      Unusual
      Username
      UserCreateDate
      UserLastModifiedDate
      Email
      Status
      Role
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminUsersQueryVariables,
  APITypes.GetAdminUsersQuery
>;
export const getMaintenanceMode = /* GraphQL */ `query GetMaintenanceMode {
  getMaintenanceMode {
    Mode
    Message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMaintenanceModeQueryVariables,
  APITypes.GetMaintenanceModeQuery
>;
export const getPortalAlert = /* GraphQL */ `query GetPortalAlert {
  getPortalAlert {
    Mode
    Message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPortalAlertQueryVariables,
  APITypes.GetPortalAlertQuery
>;
export const getDataIssueMaintenanceMode =
  /* GraphQL */ `query GetDataIssueMaintenanceMode {
  getDataIssueMaintenanceMode {
    Message
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDataIssueMaintenanceModeQueryVariables,
    APITypes.GetDataIssueMaintenanceModeQuery
  >;
export const getDataIssueMaintenanceAccounts =
  /* GraphQL */ `query GetDataIssueMaintenanceAccounts {
  getDataIssueMaintenanceAccounts {
    items {
      AccountID
      AccountName
      AccountNumber
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDataIssueMaintenanceAccountsQueryVariables,
    APITypes.GetDataIssueMaintenanceAccountsQuery
  >;
export const getPublicIpAddress = /* GraphQL */ `query GetPublicIpAddress {
  getPublicIpAddress {
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPublicIpAddressQueryVariables,
  APITypes.GetPublicIpAddressQuery
>;
export const getSharepointDocuments =
  /* GraphQL */ `query GetSharepointDocuments(
  $ContactID: String
  $ProfessionalContactID: String
  $AccountID: String
) {
  getSharepointDocuments(
    ContactID: $ContactID
    ProfessionalContactID: $ProfessionalContactID
    AccountID: $AccountID
  ) {
    AccountID
    AccountName
    ChildAccounts {
      AccountID
      AccountName
      __typename
    }
    ProfessionalFirmID
    DocumentCategories {
      CategoryName
      DocumentFiles {
        FileID
        FileName
        Date
        DocumentCategory
        __typename
      }
      __typename
    }
    LatestDocuments {
      FileID
      FileName
      Date
      DocumentCategory
      __typename
    }
    AllDocuments {
      FileID
      FileName
      Date
      DocumentCategory
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSharepointDocumentsQueryVariables,
    APITypes.GetSharepointDocumentsQuery
  >;
export const getSharepointDocumentDownloadDetails =
  /* GraphQL */ `query GetSharepointDocumentDownloadDetails(
  $ContactID: String
  $ProfessionalContactID: String
  $FileID: String
) {
  getSharepointDocumentDownloadDetails(
    ContactID: $ContactID
    ProfessionalContactID: $ProfessionalContactID
    FileID: $FileID
  ) {
    FileName
    FileID
    Url
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSharepointDocumentDownloadDetailsQueryVariables,
    APITypes.GetSharepointDocumentDownloadDetailsQuery
  >;
export const getUnsignedApprovalDocDownloadDetails =
  /* GraphQL */ `query GetUnsignedApprovalDocDownloadDetails(
  $ContactID: String
  $ApprovalDocID: String
) {
  getUnsignedApprovalDocDownloadDetails(
    ContactID: $ContactID
    ApprovalDocID: $ApprovalDocID
  ) {
    ID
    DocName
    DocFileName
    DocUrl
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetUnsignedApprovalDocDownloadDetailsQueryVariables,
    APITypes.GetUnsignedApprovalDocDownloadDetailsQuery
  >;
export const getSignedApprovalDocDownloadDetails =
  /* GraphQL */ `query GetSignedApprovalDocDownloadDetails(
  $ContactID: String
  $ApprovalDocID: String
  $resourceId: String
) {
  getSignedApprovalDocDownloadDetails(
    ContactID: $ContactID
    ApprovalDocID: $ApprovalDocID
    resourceId: $resourceId
  ) {
    FileName
    FileID
    Url
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetSignedApprovalDocDownloadDetailsQueryVariables,
    APITypes.GetSignedApprovalDocDownloadDetailsQuery
  >;
export const getActionApprovalDoc =
  /* GraphQL */ `query GetActionApprovalDoc($ContactID: String, $ApprovalDocID: String) {
  getActionApprovalDoc(ContactID: $ContactID, ApprovalDocID: $ApprovalDocID) {
    ID
    AccountGUID
    ContactGUID
    DocName
    DocFileName
    DocScope
    DocumentRepository
    Process
    Variabilty
    ActionStatus
    completedAt
    reminderCount
    createdAt
    updatedAt
    SharepointFileId
    SharepointFileName
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetActionApprovalDocQueryVariables,
    APITypes.GetActionApprovalDocQuery
  >;
export const getActionApprovalDocs =
  /* GraphQL */ `query GetActionApprovalDocs($ContactID: String) {
  getActionApprovalDocs(ContactID: $ContactID) {
    items {
      ID
      AccountGUID
      ContactGUID
      DocName
      DocFileName
      DocScope
      DocumentRepository
      Process
      Variabilty
      ActionStatus
      completedAt
      reminderCount
      createdAt
      updatedAt
      SharepointFileId
      SharepointFileName
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetActionApprovalDocsQueryVariables,
    APITypes.GetActionApprovalDocsQuery
  >;
export const getJointAccountHolderActionApprovalDoc =
  /* GraphQL */ `query GetJointAccountHolderActionApprovalDoc(
  $ContactID: String
  $DocumentRepository: String
  $DocFileName: String
) {
  getJointAccountHolderActionApprovalDoc(
    ContactID: $ContactID
    DocumentRepository: $DocumentRepository
    DocFileName: $DocFileName
  ) {
    ID
    AccountGUID
    ContactGUID
    DocName
    DocFileName
    DocScope
    DocumentRepository
    Process
    Variabilty
    ActionStatus
    completedAt
    reminderCount
    createdAt
    updatedAt
    SharepointFileId
    SharepointFileName
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetJointAccountHolderActionApprovalDocQueryVariables,
    APITypes.GetJointAccountHolderActionApprovalDocQuery
  >;
export const getContactStatusesFromOneView =
  /* GraphQL */ `query GetContactStatusesFromOneView($ContactID: String) {
  getContactStatusesFromOneView(ContactID: $ContactID) {
    atrStatus
    atrLastUpdated
    atrDateSubmitted
    factfindStatus
    factfindLastUpdated
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetContactStatusesFromOneViewQueryVariables,
    APITypes.GetContactStatusesFromOneViewQuery
  >;
export const getClientDocumentReads =
  /* GraphQL */ `query GetClientDocumentReads($ContactID: String) {
  getClientDocumentReads(ContactID: $ContactID) {
    items {
      id
      ProfContactID
      ContactID
      AccountID
      DocumentCategory
      DocumentName
      DocumentEndDate
      FileID
      Platform
      ViewedBy
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetClientDocumentReadsQueryVariables,
    APITypes.GetClientDocumentReadsQuery
  >;
export const getClientWithdrawals =
  /* GraphQL */ `query GetClientWithdrawals($ContactID: String) {
  getClientWithdrawals(ContactID: $ContactID) {
    items {
      Id
      accountId
      planId
      productCategory
      portalOwnershipName
      withdrawalAmount
      withdrawAllFunds
      createdAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetClientWithdrawalsQueryVariables,
    APITypes.GetClientWithdrawalsQuery
  >;
export const getClientWithdrawalsAllow =
  /* GraphQL */ `query GetClientWithdrawalsAllow($ContactID: String) {
  getClientWithdrawalsAllow(ContactID: $ContactID) {
    items {
      withdrawalMode
      spouseWithdrawalMode
      createdBy
      createdAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetClientWithdrawalsAllowQueryVariables,
    APITypes.GetClientWithdrawalsAllowQuery
  >;
export const getClientAttemptWithdrawals =
  /* GraphQL */ `query GetClientAttemptWithdrawals($ContactID: String) {
  getClientAttemptWithdrawals(ContactID: $ContactID) {
    items {
      Id
      accountId
      contactId
      createdAt
      planId
      portalOwnershipName
      productCategory
      result
      status
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetClientAttemptWithdrawalsQueryVariables,
    APITypes.GetClientAttemptWithdrawalsQuery
  >;
export const getAdviserDocumentReads =
  /* GraphQL */ `query GetAdviserDocumentReads($ProfessionalContactID: String) {
  getAdviserDocumentReads(ProfessionalContactID: $ProfessionalContactID) {
    items {
      id
      ProfContactID
      ProfFirmID
      DocumentCategory
      DocumentName
      DocumentEndDate
      FileID
      Platform
      ViewedBy
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAdviserDocumentReadsQueryVariables,
    APITypes.GetAdviserDocumentReadsQuery
  >;
export const getActiveLink =
  /* GraphQL */ `query GetActiveLink($id: ID, $resourceId: String, $resourceType: String) {
  getActiveLink(id: $id, resourceId: $resourceId, resourceType: $resourceType) {
    id
    contactId
    resourceId
    resourceType
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetActiveLinkQueryVariables,
    APITypes.GetActiveLinkQuery
  >;
export const getActiveLinkByShortId =
  /* GraphQL */ `query GetActiveLinkByShortId($shortId: String) {
  getActiveLinkByShortId(shortId: $shortId) {
    id
    contactId
    resourceId
    resourceType
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetActiveLinkByShortIdQueryVariables,
    APITypes.GetActiveLinkByShortIdQuery
  >;
export const getPartiallyObfuscatedMobileNumber =
  /* GraphQL */ `query GetPartiallyObfuscatedMobileNumber($ContactID: String) {
  getPartiallyObfuscatedMobileNumber(ContactID: $ContactID)
}
` as GeneratedQuery<
    APITypes.GetPartiallyObfuscatedMobileNumberQueryVariables,
    APITypes.GetPartiallyObfuscatedMobileNumberQuery
  >;
export const confirmAdhoc2FACode =
  /* GraphQL */ `query ConfirmAdhoc2FACode($ID: String!, $Code: String!) {
  confirmAdhoc2FACode(ID: $ID, Code: $Code) {
    id
    verifyCode
    verifySuccessful
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ConfirmAdhoc2FACodeQueryVariables,
    APITypes.ConfirmAdhoc2FACodeQuery
  >;
export const getQuestions = /* GraphQL */ `query GetQuestions {
  getQuestions {
    id
    text
    answers {
      id
      text
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuestionsQueryVariables,
  APITypes.GetQuestionsQuery
>;
export const isPlanWithdrawable =
  /* GraphQL */ `query IsPlanWithdrawable($ContactID: String, $PlanID: String) {
  isPlanWithdrawable(ContactID: $ContactID, PlanID: $PlanID) {
    PlanID
    isWithdrawable
    PlanWithdraw {
      ProductCategory
      PortalOwnershipName
      PortalOwnerID
      IsPortalOwner
      MaxDailyWithdrawal
      MaxTimeToProcess
      CurrentBalance
      MaxWithdrawalAmount
      BankAccountID
      BankAccount
      AccountNumber
      SortCode
      AccountName
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.IsPlanWithdrawableQueryVariables,
    APITypes.IsPlanWithdrawableQuery
  >;
export const getBlockedAdhoc2FAStatus =
  /* GraphQL */ `query GetBlockedAdhoc2FAStatus($AccountID: String) {
  getBlockedAdhoc2FAStatus(AccountID: $AccountID) {
    accountId
    blocked
    contactId
    createdAt
    ipAddress
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetBlockedAdhoc2FAStatusQueryVariables,
    APITypes.GetBlockedAdhoc2FAStatusQuery
  >;
export const recordAnalyticsEvent =
  /* GraphQL */ `query RecordAnalyticsEvent($input: AnalyticsEventInput) {
  recordAnalyticsEvent(input: $input) {
    completed
    __typename
  }
}
` as GeneratedQuery<
    APITypes.RecordAnalyticsEventQueryVariables,
    APITypes.RecordAnalyticsEventQuery
  >;
export const getForms = /* GraphQL */ `query GetForms($ContactID: String) {
  getForms(ContactID: $ContactID) {
    items {
      completed
      description
      id
      reminderCount
      title
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFormsQueryVariables, APITypes.GetFormsQuery>;
export const getInvitation = /* GraphQL */ `query GetInvitation($id: ID!) {
  getInvitation(id: $id) {
    id
    link
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvitationQueryVariables,
  APITypes.GetInvitationQuery
>;
export const getStructuredProduct =
  /* GraphQL */ `query GetStructuredProduct($id: ID!) {
  getStructuredProduct(id: $id) {
    administrator
    barrierLevel
    barrierObservation {
      downside
      percentage
      type
      __typename
    }
    benchmark {
      history {
        level
        valueEnd
        frequency
        valueStart
        performance
        performanceId
        periodEndDate
        negativeCashFlow
        positiveCashFlow
        modifiedPerformance
        __typename
      }
      id
      name
      __typename
    }
    counterparty
    custodian
    finalIndexDate
    finalIndexLevel
    finalReferenceLevel
    id
    indexEndValue
    indexStartValue
    initialIndexLevel
    investmentType
    isin
    maturityDate
    name
    productDescription
    productType
    ratings {
      fitch
      moody
      sAndP
      __typename
    }
    results {
      description
      growthReturnIncluding
      growthReturnPercentage
      __typename
    }
    sedol
    strike {
      dates {
        earlyMaturityDate
        earlyMaturityPotentialGain
        earlyMaturityReferenceLevel
        __typename
      }
      price
      priceDate
      __typename
    }
    term
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetStructuredProductQueryVariables,
    APITypes.GetStructuredProductQuery
  >;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    ContactID
    Message
    LinkUrl
    LinkText
    LinkRedirectCommand
    LinkActionApprovalDocID
    IsRead
    IsClicked
    ShowToast
    SendEmail
    EmailSubject
    EmailMessage
    disabled
    expireAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $id: ID
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotifications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      ContactID
      Message
      LinkUrl
      LinkText
      LinkRedirectCommand
      LinkActionApprovalDocID
      IsRead
      IsClicked
      ShowToast
      SendEmail
      EmailSubject
      EmailMessage
      disabled
      expireAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
